import { Api, ApiError } from '@TaankYou/api';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

var isObject = function (item) { return (item && typeof item === 'object' && !Array.isArray(item)); };
var mergeDeep = function (target) {
    var _a, _b;
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    if (!sources.length)
        return target;
    var source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for (var key in source) {
            if (isObject(source[key])) {
                if (target[key] === undefined)
                    Object.assign(target, (_a = {}, _a[key] = {}, _a));
                mergeDeep(target[key], source[key]);
            }
            else
                Object.assign(target, (_b = {}, _b[key] = source[key], _b));
        }
    }
    return mergeDeep.apply(void 0, __spreadArray([target], sources));
};
/**
 * Function used to format url args from a dictionnary or an array
 *
 * @param {string[] | {[key: string]: string | number}} opt the arguments dictionnary or array
 * @returns {string} the options formatted for url
 */
var OptFormater = function (opt) {
    var optArr = opt;
    if (isObject(opt)) {
        optArr = [];
        for (var _i = 0, _a = Object.entries(opt); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            var isArray = Array.isArray(value);
            if (isArray)
                optArr.push("".concat(key, "=").concat(value.join(",")));
            else
                optArr.push("".concat(key, "=").concat(value));
        }
    }
    if (!Array.isArray(optArr))
        return "";
    var optStr = "";
    optStr = optArr.join("&");
    if (optStr.length)
        optStr = "?".concat(optStr);
    return optStr;
};

var DEFAULT_CONFIG = {
    mockTimeout: 1000,
    defaultErrorMessage: "An error occured",
    apiBaseUrl: null
};
var config;
var api;
var ServicesInit = function (conf) {
    config = mergeDeep({}, DEFAULT_CONFIG, conf);
    api = new Api(config.apiBaseUrl);
};

/**
 * Function to wrap service method in when creating a mock of a service
 *
 * @param {MockFuncType} mockFunc the function that will return results
 * @param {number} timeout Time in ms for simulating the loading time.
 */
var Mock = function (mockFunc, timeout) {
    if (timeout === undefined)
        timeout = config.mockTimeout;
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            var result = undefined;
            try {
                result = mockFunc();
                resolve(result);
            }
            catch (e) {
                reject(new ApiError(e));
            }
        }, timeout);
    });
};
/**
 * Used to filter the list for mock
 *
 * @param {any[]} list the array to be filtered
 * @param {FilterOptionsType} options The filters to apply {key: value, ...}
 * @param {FilterCheckType} checkFunc A dictionnary of function to be used to compare specific key
 */
var FilterList = function (list, options, checkFunc) {
    if (checkFunc === void 0) { checkFunc = {}; }
    if (!options)
        return list;
    return list.filter(function (item) {
        return Object.keys(options)
            .map(function (k) { return item[k] !== undefined && (checkFunc[k] ? checkFunc[k](item[k], options[k]) : item[k] === options[k]); })
            .every(function (b) { return b; });
    });
};

/**
 * Base class for services
 * All written service must extend this one.
 */
var Service = /** @class */ (function () {
    function Service() {
        var _this = this;
        this.errorsHandler = function (e) { throw e; };
        this.pathPrepend = "";
        this._get = function (endpoint, options) {
            return api.Get("".concat(_this.pathPrepend).concat(endpoint), options)["catch"](_this.errorsHandler);
        };
        this._put = function (endpoint, data, options) {
            return api.Put("".concat(_this.pathPrepend).concat(endpoint), data, options)["catch"](_this.errorsHandler);
        };
        this._patch = function (endpoint, data, options) {
            return api.Patch("".concat(_this.pathPrepend).concat(endpoint), data, options)["catch"](_this.errorsHandler);
        };
        this._post = function (endpoint, data, options) {
            return api.Post("".concat(_this.pathPrepend).concat(endpoint), data, options)["catch"](_this.errorsHandler);
        };
        this._del = function (endpoint, data, options) {
            return api.Del("".concat(_this.pathPrepend).concat(endpoint), data, options)["catch"](_this.errorsHandler);
        };
        this._mock = function (f, timeout) {
            if (timeout === void 0) { timeout = undefined; }
            return Mock(f, timeout)["catch"](_this.errorsHandler);
        };
        if (!api)
            throw new Error("Services, Api object not initialised. Have you called InitServices ?");
    }
    return Service;
}());

/**
 * Handler used to react to Api Request errors
 *
 * @param {ApiError} error Error object raised by the request call
 * @param {ErrorHandlerType} handler Object or function that can handle reaction for subcode
 * @param {string} defaultMsg Default message for error if not found by handler
 */
var ServiceErrorHandler = function (error, handler, defaultMsg) {
    if (handler === void 0) { handler = {}; }
    var transmitError = true;
    var notif = {
        type: "error",
        desc: defaultMsg
    };
    if (!defaultMsg)
        defaultMsg = (config === null || config === void 0 ? void 0 : config.defaultErrorMessage) || "";
    if (error.subcode) {
        if (typeof handler === "function")
            transmitError = handler(error.subcode);
        else {
            var errorDesc = handler[error.subcode] || defaultMsg;
            var __ = (config === null || config === void 0 ? void 0 : config.translationFunction) || function (str) { return str; };
            //transmitError = true;
            if (typeof errorDesc === "string")
                notif.desc = __(errorDesc) || errorDesc;
            else {
                notif = {
                    type: errorDesc["type"] || "error",
                    desc: __(errorDesc["message"] || defaultMsg)
                };
                transmitError = errorDesc["transmit"] || false;
            }
        }
        if (transmitError === undefined)
            transmitError = true;
    }
    if (config === null || config === void 0 ? void 0 : config.onError)
        config.onError(error);
    if (config === null || config === void 0 ? void 0 : config.notifyError)
        config.notifyError(notif);
    if (transmitError)
        throw error;
};

export { DEFAULT_CONFIG, FilterList, Mock, OptFormater, Service, ServiceErrorHandler, ServicesInit, api, config, isObject, mergeDeep };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@TaankYou/services/dist/index.es.js
// module id = ./node_modules/@TaankYou/services/dist/index.es.js
// module chunks = 0